/**
 * Lazy load functionality
 */
export default class LazyLoad {
  /**
   * Constructor of lazy load element
   * @param {NodeList} elements - Element to bind on
   */
  constructor(elements) {
    this._elements = elements;

    // Observe the images
    const imgObserver = this.#imageObserver();
    this._elements.forEach((element) => {
      imgObserver.observe(element);
      element.setAttribute('observing-lazyload', true);
    });
  }

  /**
   * Start observing the lazy load element
   * @return {IntersectionObserver} Intersection Observer for lazy load elements
   */
  #imageObserver() {
    return new IntersectionObserver((entries, imgObserver) => {
      entries.forEach((entry) => {
        // If the image is not in view
        if (!entry.isIntersecting) {
          return;
        }

        // If image element is in view
        const img = entry.target;

        // Set image source or background image
        if (img.tagName === 'IMG') {
          img.src = img.getAttribute('lazyload');
        } else {
          img.style.backgroundImage = `url(${img.getAttribute('lazyload')})`;
        }

        // Remove lazyload attribute after the image has been loaded
        img.removeAttribute('lazyload');
        img.removeAttribute('observing-lazyload');

        imgObserver.unobserve(entry.target);
      });
    });
  }

  /**
   * Static init function for lazy load images
   * @static
   */
  static init() {
    // Get lazy load elements that have not been initialized yet
    const lazyLoadElements = Array.from(document.querySelectorAll('[lazyload]'))?.filter(element => element.getAttribute('lazyload') && !element.getAttribute('observing-lazyload'));

    if (lazyLoadElements.length) {
      new LazyLoad(lazyLoadElements);
    }
  }
}
